import React from 'react';
import EventPageTemplate from './EventPageTemplate';
import { eventData } from '../data/eventContent';

const PrivatePartiesPage: React.FC = () => {
  return <EventPageTemplate {...eventData['private-parties']} />;
};

export default PrivatePartiesPage;